import { render, staticRenderFns } from "./personalCenter.vue?vue&type=template&id=336a49d5&scoped=true&"
import script from "./personalCenter.vue?vue&type=script&lang=js&"
export * from "./personalCenter.vue?vue&type=script&lang=js&"
import style0 from "./personalCenter.vue?vue&type=style&index=0&id=336a49d5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336a49d5",
  null
  
)

export default component.exports